import DashboardPhoneNumberInput from "./DashboardPhoneNumberInput";

export default DashboardPhoneNumberInput;